export default __webpack_public_path__ + "static/media/Greg_Wang.50ca81e7.jpg";